<script setup>
import { ref, defineProps, defineEmits } from 'vue'

// New-design dark floating row action bar (.actionbar):
// appears on row hover, see admin.scss.
defineProps({
  copies: { type: Array, default: () => [] }, // [{ icon, label, text }]
  detailLabel: { type: String, default: '' },
  deletable: { type: Boolean, default: false },
})

const emit = defineEmits(['detail', 'delete'])

const copiedIdx = ref(null)
function copy(item, idx) {
  try {
    navigator.clipboard.writeText(String(item.text)).catch(() => {})
  } catch (err) { /* clipboard unavailable — fail silently */ }
  copiedIdx.value = idx
  setTimeout(() => { copiedIdx.value = null }, 1200)
}
</script>

<template>
  <div class="actionbar">
    <button
      v-for="(item, idx) in copies"
      :key="idx"
      class="ab"
      :class="{ done: copiedIdx === idx }"
      :title="item.label"
      type="button"
      @click.stop="copy(item, idx)">
      <span class="mdi" :class="copiedIdx === idx ? 'mdi-check' : `mdi-${item.icon}`"></span>
    </button>
    <button v-if="detailLabel" class="ab-detail" type="button" @click.stop="emit('detail')">
      {{ detailLabel }}
      <span class="mdi mdi-arrow-right"></span>
    </button>
    <button v-if="deletable" class="ab ab-danger" title="Delete" type="button" @click.stop="emit('delete')">
      <span class="mdi mdi-trash-can-outline"></span>
    </button>
  </div>
</template>
